import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useAssessDialogStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        // Stacks the reference card above the collapsible note/form. No gap: the spacing lives inside the
        // collapse (collapseContent) so it animates away with the content instead of leaving a dead gap.
        stage: {
            display: "flex",
            flexDirection: "column",
        },
        collapseContent: {
            paddingTop: theme.spacing(4),
        },
        // The dialog uppercases its title; the scenario subtitle opts out of that and reads as quiet supporting text.
        dialogSubtitle: {
            display: "block",
            textTransform: "none",
            fontSize: "0.875rem",
            fontWeight: theme.typography.fontWeightRegular,
            color: theme.palette.text.secondary,
            marginTop: theme.spacing(0.25),
        },
        // DotLegalLink has no font-size control; the descendant selector keeps the carry-forward link at 14px.
        carryForward: {
            marginTop: theme.spacing(0.5),
            "& a, & span": {
                fontSize: "0.875rem",
            },
        },
    });
};
